import { Controller } from "@hotwired/stimulus"

import { formatPrice } from "@/helpers/price_format"

export default class extends Controller {
  static targets = ["priceSummary", "submitButton", "totalPrice"]
  declare readonly priceSummaryTarget: HTMLElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly totalPriceTarget: HTMLElement

  static values = {
    calendarFormId: String,
    calendarLastStep: Boolean,
    paxFormId: String,
    purchaseFormId: String
  }
  declare readonly calendarFormIdValue: string
  declare readonly calendarLastStepValue: boolean
  declare readonly paxFormIdValue: string
  declare readonly purchaseFormIdValue: string

  setCalendarSubmit({
    isDateSelected,
    isSpaDay
  }: {
    isDateSelected: boolean
    isSpaDay: boolean
  }): void {
    const formId = this.calendarLastStepValue ? this.purchaseFormIdValue : this.calendarFormIdValue
    const nextStepText = this.calendarLastStepValue ? "Book now" : "Next"
    const buttonText = isDateSelected ? nextStepText : "Select date"

    this.updateSubmitButton(formId, buttonText, !isDateSelected)
    this.priceSummaryTarget.hidden = !isSpaDay || !isDateSelected
  }

  setFacilitiesSubmit(isFacilitySelected: boolean): void {
    const buttonText = isFacilitySelected ? "Book now" : "Select facility use"

    this.updateSubmitButton(this.purchaseFormIdValue, buttonText, !isFacilitySelected)
    this.priceSummaryTarget.hidden = false // Always visible as facility selection does not affect price
  }

  setPriceTarget(value: number): void {
    this.totalPriceTarget.textContent = formatPrice(value)
  }

  setPaxSubmit(): void {
    this.updateSubmitButton(this.paxFormIdValue, "Next", false)
    this.priceSummaryTarget.hidden = true
  }

  setRoomsSubmit(isAllRoomsSelected: boolean): void {
    const buttonText = isAllRoomsSelected ? "Book now" : "Select rooms"

    this.updateSubmitButton(this.purchaseFormIdValue, buttonText, !isAllRoomsSelected)
    this.priceSummaryTarget.hidden = !isAllRoomsSelected
  }

  private updateSubmitButton(formId: string, textContent: string, disabled: boolean): void {
    this.submitButtonTarget.setAttribute("form", formId)
    this.submitButtonTarget.textContent = textContent
    this.submitButtonTarget.disabled = disabled
  }
}
